/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

var props = {
  closeBtn: {
    type: [String, Boolean, Function],
    "default": true
  },
  colorModes: {
    type: Array,
    "default": function _default() {
      return ["monochrome", "linear-gradient"];
    }
  },
  disabled: Boolean,
  enableAlpha: Boolean,
  format: {
    type: String,
    "default": "RGB",
    validator: function validator(val) {
      if (!val) return true;
      return ["RGB", "RGBA", "HSL", "HSLA", "HSB", "HSV", "HSVA", "HEX", "CMYK", "CSS"].includes(val);
    }
  },
  inputProps: {
    type: Object
  },
  multiple: Boolean,
  popupProps: {
    type: Object
  },
  recentColors: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  defaultRecentColors: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  selectInputProps: {
    type: Object
  },
  swatchColors: {
    type: Array
  },
  value: {
    type: String,
    "default": ""
  },
  defaultValue: {
    type: String,
    "default": ""
  },
  onChange: Function,
  onPaletteBarChange: Function,
  onRecentColorsChange: Function
};

export { props as default };
//# sourceMappingURL=props.js.map
